// extracted by mini-css-extract-plugin
export default {"confirmModalText":"remove_confirm_modal-module___confirmModalText___e38309c2"};